import { useStateValue } from '../StateProvider';
import { getDefaultValue } from '../utils';

export default function TranslateController() {
  const [{ translations }] = useStateValue();

  const _t = (key, defaultValue = null) => {
    const fallback = defaultValue == null ? key : defaultValue;
    if (!translations) return fallback;

    const translated = translations.find((x) => x.key == key);
    return translated ? getDefaultValue(translated) : `#${key}`;
  };

  return { _t };
}
